export const RoutesPaths = {
  LANDING: "/",
  ABOUTUS: "/about-us",
  DENIRA: "/denira",
  RENEWABLEENERGY: "/renewable-energy",
  OILGAS: "/oil-gas",
  EPC: "/epc-Infrastructure",
  ESG: "/esg-commitment",
  CONTACTUS: "/contact-us",
  PRIVACYPOLICY: "/privacy-policy",
  TERMSCONDITIONS: "/terms-conditions",
  NOTFOUND: "/not-found",
};

// export const backendUrl = "http://192.168.1.18:4000/api/";
export const backendUrl = "https://api.staging.quimera.ao/api/";
